<div class="px-6 pt-5 pb-4 border-b border-gray-100">
  <h3 class="text-lg font-semibold">Choisissez vos produits offerts</h3>

  @if (isFixedAmountReduction()) {
  <div
     class="mt-2 inline-flex items-center gap-1.5 bg-green-50 border border-green-200
            text-green-700 text-sm font-semibold px-3 py-1.5 rounded-full">
    🎁 Remise de {{ getFixedAmountValue() }}€ sur le total des produits offerts
    </div>
  }
  @if (isSetPriceReduction()) {
  <div
     class="mt-2 inline-flex items-center gap-1.5 bg-green-50 border border-green-200
          text-green-700 text-sm font-semibold px-3 py-1.5 rounded-full">
    🎉
    @for (cat of offeredCategories; track trackCompositionLine(cat.category.id + '-' + cat?.size?.id, i); let i = $index; let last = $last)
  {
  {{ cat.quantity }} {{ cat.category.name }}@if (!last) {
  <span>+ </span>
  }
  }
  à seulement {{ getFixedAmountValue() }}€
  </div>
  }
</div>

<mat-dialog-content class="p-4 overflow-y-auto">
  <div class="flex flex-col gap-3">
    @for (cat of offeredCategories; track trackCompositionLine(cat.category.id + '-' + cat?.size?.id, i); let i =
    $index) {
    <div
      [id]="'category-' + i">
      <div class="flex items-center gap-2 mb-3 flex-wrap">
        <span class="bg-green-500 text-white text-xs font-semibold px-2 py-1 rounded-full">
    {{ cat.quantity }}x offert{{ cat.quantity > 1 ? 's' : '' }}
    </span>
    <h3 class="text-base font-semibold text-site m-0">{{ cat.category.name }}</h3>
          @if (cat.size) {
    <span
      class="bg-purple-100 text-purple-700 text-xs px-2 py-0.5 rounded-full border border-purple-300">
              {{ cat.size.name }}
            </span>
    }
    </div>
    <div class="grid grid-cols-[repeat(auto-fill,minmax(130px,1fr))] gap-2.5">
      @for (product of cat.products; track trackCompositionLine(product.id, pi); let pi = $index) {

    <div class="relative bg-base-200 rounded-2xl overflow-hidden
                transition-all duration-200"
         [class.border-secondary]="getProductQuantity(i, product.id) > 0"
         [class.border]="getProductQuantity(i, product.id) > 0"
         [class.shadow-md]="getProductQuantity(i, product.id) > 0"
         [class.border-gray-200]="getProductQuantity(i, product.id) === 0"
         [class.opacity-60]="!product.available">
      <div class="relative w-full h-36 overflow-hidden rounded-[12px]">
        <img [ngSrc]="product.image || 'assets/images/placeholders/placeholder.webp'"
             [alt]="product.name || 'Image à venir'"
             fill
             loading="lazy"
             sizes="(max-width: 640px) 50vw, 20vw"
             class="object-contain" />
        @if (getDiscountBadge()) {
        <span
      class="absolute top-1.5 left-1.5 bg-green-100 text-green-700
     text-[0.7rem] font-bold px-1.5 py-0.5 rounded-full border border-green-200">
        {{ getDiscountBadge() }}
        </span>
        }
        @if (!product.available) {
        <div
          class="absolute inset-0 bg-black/50 flex items-center justify-center">
          <span class="text-white text-xs font-semibold">Indisponible</span>
        </div>
        }
      </div>
      <div class="p-2">
        <p class="text-[0.8rem] font-medium text-site mb-1 leading-snug line-clamp-2">
          {{ product.name }}
        </p>
        @if (productHasSizes()) {
        <div class="mb-4">
          <mat-form-field appearance="outline" class="w-full text-sm">
            <mat-select
              [value]="selectedSizeId || ''"
              (selectionChange)="onSizeChange($event.value)"
              placeholder="Choisir une taille...">
              <mat-option value="">
                Choisir une taille...
              </mat-option>
              @for (size of getProductSizes(); track trackCompositionLine(size.id, $index)) {
        <mat-option [value]="size.id">
          {{ size.name }}
        </mat-option>
        }
        </mat-select>
      </mat-form-field>
    </div>
        }
        @if (productHasSizes()) {
        <div class="mb-3">
          <p class="text-site font-bold text-base">
            @if (getProductPrice() > 0) {
        <span>{{ getProductPrice() | number:'1.2-2' }} €</span>
        }
        @if (getProductPrice() === 0) {
        <span class="text-gray-400 text-sm font-normal">
                            Choisissez une taille pour continuer
                          </span>
        }
        </p>
      </div>
        }
        @if (isFree()) {
        <p class="text-[0.82rem] font-bold text-green-500">Gratuit</p>
        }
        @if (!isFree()) {
        <div class="flex flex-col gap-0.5">
          @if (isFixedAmountReduction()) {
        <!-- Pour FIXED_AMOUNT : Pas de prix barré, on affiche directement le prix de base du produit -->
        <span class="text-[0.85rem] font-bold text-site">
        {{ getBasePrice(product) | number:'1.2-2' }} €
      </span>
        } @else {
        <!-- Pour les pourcentages % : Prix barré + Prix remisé -->
        <span class="text-xs text-gray-400 line-through">
        {{ getBasePrice(product) | number:'1.2-2' }} €
      </span>
        <span class="text-[0.85rem] font-bold text-primary">
        {{ getFinalPrice(product) | number:'1.2-2' }} €
      </span>
        }
        </div>
        }
        <!--            <ng-container *ngIf="isFixedAmountReduction() && !isSetPriceReduction()">-->
        <!--              <p class="text-[0.85rem] font-bold text-primary">-->
        <!--                {{ getBasePrice(product) | number:'1.2-2' }} €-->
        <!--              </p>-->
        <!--            </ng-container>-->
        @if (product.available) {
        <div class="flex items-center justify-center gap-2 mt-2">
          <button
            class="w-7 h-7 cursor-pointer rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
            [disabled]="getProductQuantity(i, product.id) === 0"
            (click)="decrementProduct(i, product.id)">
            -
          </button>
          <span class="font-bold min-w-[20px] text-center text-sm">
        {{ getProductQuantity(i, product.id) }}
        </span>
        <button
          class="w-7 h-7 cursor-pointer rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
          [disabled]="getTotalSelectedInCategory(i) >= cat.quantity"
          (click)="incrementProduct(i, product)">
          +
        </button>
      </div>
        }
      </div>
    </div>
    }
    </div>
    @if (cat.selectedProductIds.length < cat.quantity) {
    <p class="text-xs text-amber-500 mt-2">
      ⚠️ {{ cat.selectedProductIds.length }}/{{ cat.quantity }} sélectionné{{ cat.quantity > 1 ? 's' : '' }}
    </p>
    }
    </div>
    }
  </div>


</mat-dialog-content>
<div class="px-6 py-4 border-t border-gray-100">

  @if (hasSelection()) {
  <div class="mb-4 p-4 bg-green-50 rounded-lg overflow-y-auto" style="max-height: 120px;">
  <!-- Supplements list -->
  @if (getAllSelectedSupplements().length > 0) {
  <div class="mb-3 flex flex-col min-h-0">
    <p class="text-sm font-medium text-gray-700 mb-2">Suppléments choisis :</p>
    <div class="grid grid-cols-1 gap-2 text-sm">
      @for (supp of getAllSelectedSupplements(); track trackCompositionLine(supp, $index)) {
      <div
        class="flex justify-between items-center bg-white rounded-lg px-3 py-2 border border-gray-100">
        <span class="text-gray-400">
      {{ supp.name }}
      @if (supp.quantity && supp.quantity > 1) {
      <span class="text-orange-600">×{{ supp.quantity }}</span>
      }
      </span>
      <span class="font-medium text-orange-600">
        +{{ (supp.price * (supp.quantity || 1)) | number:'1.2-2' }} €
                </span>
              </div>
      }
    </div>
  </div>
  }
  <!-- ✅ Total produits = base + supplements -->
  @if (!isSetPriceReduction() && !isFree()) {
  <div class="flex justify-between text-sm">
    <span class="text-[#1A1A1A]">Total produits</span>
    <span class="font-semibold text-[#1A1A1A]">
            {{ (getTotalBasePrice() + getTotalSupplementsPrice()) | number:'1.2-2' }} €
          </span>
  </div>
  }
  <!-- ✅ Remise applied only on base price -->
  @if (!isSetPriceReduction() && !isFree()) {
  <div class="flex justify-between text-sm text-green-700 mt-1">
          <span>
            Remise
            @if (data.rule.reduction?.type === 'PERCENTAGE') {
            ({{ (data.rule.reduction?.value || 0) * 100 | number:'1.0-0' }}%)
            }
          </span>
    <span class="font-bold">- {{ getDiscountAmount() | number:'1.2-2' }} €</span>
  </div>
  }
  <!-- ✅ Total = (base - discount) + supplements -->
  <div class="flex justify-between border-t border-green-200 pt-3 mt-3 font-bold text-[#1A1A1A]">
    <span>Total après remise</span>
    <span class="text-orange-600">{{ getTotalAfterDiscount() | number:'1.2-2' }} €</span>
      </div>
    </div>
  }
  @if (getNextRemainingChoice(); as r) {
  <button
    type="button"
    (click)="scrollToCategory(r.index)"
    class="w-full mb-2 flex items-center justify-center gap-2 text-center cursor-pointer
           bg-orange-50 border border-orange-300 text-orange-700 rounded-lg
           px-3 py-2 text-sm font-semibold">
    <span>⚠️</span>
    <span>
      Choisissez "{{ r.label }}"
      ({{ r.remaining }} choix restant{{ r.remaining > 1 ? 's' : '' }})
    </span>
  </button>
  }
  <div class="flex gap-3">
    <button (click)="cancel()"
            [matButton]="themeConfig.appearance.button.cancel"
            class="flex-1 py-2.5">
      Annuler
    </button>

    <button
      [matButton]="themeConfig.appearance.button.action"
      (click)="confirm()"
      [disabled]="!allSelected()"
      class="flex-1 py-2.5  ">
      Confirmer
    </button>
    <!--    <button-->
    <!--      (click)="confirm()"-->
    <!--      [disabled]="productHasSizes() && !selectedSizeId"-->
    <!--      class="... disabled:bg-gray-300 disabled:cursor-not-allowed">-->
    <!--      Confirmer-->
    <!--    </button>-->
  </div>
</div>
